<template>
	<div class="table_container">
		<eTable
			:height="tableHeight"
			:isOnlyCollect="true"
			:hiddenFilter="true"
			:canSelect="false"
		></eTable>
	</div>
</template>

<script>
import eTable from '@/components/multiFactorTable/index.vue'
export default {
	name: "basedata",
	components: {
		eTable
	},
	data() {
		return {
			tableHeight: 0,
			tableKey: Math.random()
		};
	},
	created() {
		// this.getData();
	},
	methods: {
		getHeight(){
			this.tableHeight=document.querySelector('.content-box .content .e_table').offsetHeight - 60
		},
		onResize(){
			window.addEventListener('resize', ()=>{
				this.getHeight()
			})
		},
	},
	mounted() {
		this.onResize()
		this.getHeight()
		this.tableKey=Math.random()
	},
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.table_container{
	width: 100%;
	height: 100%;
	overflow: hidden;
}
</style>
